module.exports = __webpack_public_path__ + "img/spine2.3f39e0e9.jpg";